import { orchestrator } from 'satcheljs';
import {
    removeRetentionPolicy,
    deleteRetentionPolicyRow,
    addRetentionPolicyRow,
    updateUserConfigurationOnRemovePolicy,
} from '../actions/internalActions';
import getActivePoliciesListState from '../selectors/getActivePoliciesListState';
import removeActivePolicyTags from '../services/removeActivePolicyTags';
import * as trace from 'owa-trace';

export default orchestrator(removeRetentionPolicy, async actionMessage => {
    const { retentionId } = actionMessage;
    try {
        const activePolicies = getActivePoliciesListState();
        const policyRow = activePolicies.retentionPolicies.get(retentionId);
        const policyIndex = activePolicies.retentionPolicyIds.indexOf(retentionId);
        if (policyIndex > -1) {
            deleteRetentionPolicyRow(retentionId, policyIndex);
        } else {
            trace.trace.warn(`Policy with id ${retentionId} not found in list of active policies`);
            // Do not return here, call the service anyways
        }
        const response = await removeActivePolicyTags([policyRow.Identity.RawIdentity]);

        if (!response.WasSuccessful) {
            // add the policy back to the list
            addRetentionPolicyRow(policyRow, retentionId, policyIndex);
            // TODO 39892 : User prompt handling
        }
        // retention policies in user configuration need to be updated so that we can serve updated options from context menu
        updateUserConfigurationOnRemovePolicy([policyRow]);
    } catch (e) {
        trace.errorThatWillCauseAlert(e);
        return;
    }
});
